export const Product = {
  1: 'SRMT',
  4: 'LCRMT',
  2: 'AML & RG',
  8: 'CRMT'
};

export const ProductAlert = {
  1: 'srmt',
  4: 'lcrmt',
  2: 'aml',
  8: 'crmt'
};

export const ProductsAlertType = {
  1: 'Linked Account',
  2: 'Multi Account',
  3: 'Game Style',
  4: 'Financial',
  5: 'Monitoring',
  6: 'Additional',
  7: 'False Game Style',
  8: 'Opposite Betting Account',
  9: 'Suspicious Tips',
  10: 'Margin Winners',
  11: 'Game Winners',
  12: 'Winners',
  13: 'Straight Up Winners',
  14: 'AML',
  15: 'RG',
  16: 'Single Threshold',
  17: 'Multiple Account Threshold',
  18: 'Multi Account',
  19: 'Monitoring',
  20: 'Suspicious Activity',
  21: 'Advantage Play(Blackjack Main Bets)',
  30: 'Advantage Play(Blackjack Side Bets)',
  32: 'Advantage Play(Dragon Tiger Side Bets)',
  22: 'Cutting Card Placement',
  23: 'Robot Play',
  24: 'Game Anomalies(Suspicious Money Turnover)',
  33: 'Cumulative Loss',
  25: 'AML Combined Alerts',
  26: 'Suspicious Patterns',
  27: 'AML',
  28: 'P2P Alert',
  29: 'Multi Account',
  31: 'Single Alert',
  34: 'Market Monitoring Alerts',
  35: 'General Alert',
  36: 'Game Anomalies(Suspicious Game Activity)',
  37: 'Player Anomalies(Negative NGR)',
  38: 'Player Anomalies(General)',
  39: 'Behavioral Anomaly'
};

export const ProductsURLAlertType = {
  1: 'linkedAccount',
  2: 'multiAccount',
  3: 'gameStyle',
  4: 'financial',
  5: 'monitoring',
  6: 'additional',
  7: 'falseGameStyle',
  8: 'opposite-betting-accounts',
  9: 'suspicious-tips',
  10: 'margin-winners',
  11: 'game-winners',
  12: 'winners',
  13: 'straight-up-winners',
  14: 'aml',
  15: 'rg',
  16: 'single-threshold',
  17: 'multiple-account-threshold',
  18: 'multiple-account',
  19: 'monitoring',
  20: 'suspicious-activity',
  21: 'advantage-play/blackjack-main-bets',
  30: 'advantage-play/blackjack-side-bets',
  32: 'advantage-play/dragon-tiger-side-bets',
  22: 'cutting-card',
  23: 'robot-play',
  24: 'anomalies/game-anomalies/suspicious-money-turnover',
  33: 'anomalies/cumulative-loss',
  25: 'amlCombined',
  26: 'suspicious-patterns',
  27: 'aml',
  28: 'p2p-alert',
  29: 'multiAccount',
  31: 'single-alert',
  34: 'market-monitoring-alerts',
  35: 'general-alert',
  36: 'anomalies/game-anomalies/suspicious-game-activity',
  37: 'anomalies/player-anomalies/player-negative-ngr',
  38: 'anomalies/player-anomalies/general',
  39: 'behavioralAnomaly'
};

export const AlertMonitorType = {
  1: 'fraud-monitor',
  2: 'info-monitor',
  3: 'daily-alerts',
  4: 'hourly-alerts',
  5: 'aml',
  6: 'studio-alerts'
};
